import React from "react";
import { Snackbar, Alert } from "@mui/material";

const TriviaAchievementToast = ({ queue, onDismiss }) => {
  const current = queue?.[0];

  return (
    <Snackbar
      open={Boolean(current)}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      autoHideDuration={2500}
      onClose={onDismiss}
    >
      <Alert severity="success" variant="filled" onClose={onDismiss}>
        Achievement unlocked: {current?.name}
      </Alert>
    </Snackbar>
  );
};

export default TriviaAchievementToast;
